"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClearStore = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
/**
 * Clears the Apollo cache and refetches all active queries.
 * Queries with errorPolicy: 'all' will handle cache reset gracefully.
 */
const useClearStore = () => {
    const client = (0, react_2.useApolloClient)();
    const clearStore = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield client.clearStore();
        }
        catch (e) {
            console.error('Can not clear the cache', e);
        }
    }), [client]);
    return {
        clearStore,
    };
};
exports.useClearStore = useClearStore;
